import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IPropertyListProperty} from "../../property/types/PropertyListProperty";
import {getAmplitudePropertyListItem, IAmplitudePropertyListMainOffer} from "./get_amplitude_property_list_item";
import {AmplitudeViewItemListLocation} from "./track_amplitude_offer_view_item_list";

export type AmplitudePropertyListView = "floor_plans" | "list";

export interface ITrackAmplitudePropertyViewItemListParams {
    offer: IAmplitudePropertyListMainOffer;
    properties: IPropertyListProperty[];
    itemListId: string;
    itemListName: string;
    location?: AmplitudeViewItemListLocation;
    listView?: AmplitudePropertyListView;
}

export const trackAmplitudePropertyViewItemList = (params: ITrackAmplitudePropertyViewItemListParams) => {
    const {offer, properties, itemListId, itemListName, location = "property_page", listView} = params;

    trackAmplitudeEvent("view_item_list", {
        item_list_id: itemListId,
        item_list_name: itemListName,
        location,
        ...(listView ? {list_view: listView} : {}),
        products: properties.map((property, index) => getAmplitudePropertyListItem({property, mainOffer: offer, index}))
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IPropertyListProperty} from "../../property/types/PropertyListProperty";
import {getAmplitudePropertyListItem, IAmplitudePropertyListMainOffer} from "./get_amplitude_property_list_item";
import {AmplitudeViewItemListLocation} from "./track_amplitude_offer_view_item_list";

export type AmplitudePropertyListView = "floor_plans" | "list";

export interface ITrackAmplitudePropertyViewItemListParams {
    offer: IAmplitudePropertyListMainOffer;
    properties: IPropertyListProperty[];
    itemListId: string;
    itemListName: string;
    location?: AmplitudeViewItemListLocation;
    listView?: AmplitudePropertyListView;
}

export const trackAmplitudePropertyViewItemList = (params: ITrackAmplitudePropertyViewItemListParams) => {
    const {offer, properties, itemListId, itemListName, location = "property_page", listView} = params;

    trackAmplitudeEvent("view_item_list", {
        item_list_id: itemListId,
        item_list_name: itemListName,
        location,
        ...(listView ? {list_view: listView} : {}),
        products: properties.map((property, index) => getAmplitudePropertyListItem({property, mainOffer: offer, index}))
    });
};
